module.exports = __webpack_public_path__ + "static/media/blower.2216db83.png";